<template>
  <div class="px-3 mb-4" id="header-wrapper">
    <div id="top-menu">
      <div class="row">
        <router-link
          :class="{ 'active-blue': firesafe.number === 1 }"
          class="menu-item col-6 text-center active"
          to="/firesafe-1/ignition"
          v-on:click.native="setFiresafe(1, 'ignition')"
        >
          FIRESAFE I
        </router-link>
        <router-link
          :class="{ 'active-blue': firesafe.number === 2 }"
          class="menu-item col-6 text-center active"
          to="/firesafe-2/detection"
          v-on:click.native="setFiresafe(2, 'detection')"
        >
          FIRESAFE II
        </router-link>
      </div>
      <div class="row">
        <router-link
          :class="{
            active: firesafe.number === 1,
            'active-blue': firesafe.type === 'ignition'
          }"
          class="menu-item col-2 text-center"
          to="/firesafe-1/ignition"
          v-on:click.native="setFiresafe(1, 'ignition')"
        >
          IGNITION
        </router-link>
        <router-link
          :class="{
            active: firesafe.number === 2,
            'active-blue': firesafe.type === 'detection'
          }"
          class="menu-item col-2 text-center"
          to="/firesafe-2/detection"
          v-on:click.native="setFiresafe(2, 'detection')"
        >
          DETECTION
        </router-link>
        <router-link
          :class="{
            active: firesafe.number === 2,
            'active-blue': firesafe.type === 'decision'
          }"
          class="menu-item col-2 text-center"
          to="/firesafe-2/decision"
          v-on:click.native="setFiresafe(2, 'decision')"
        >
          DECISION
        </router-link>
        <router-link
          :class="{
            active: firesafe.number === 1,
            'active-blue': firesafe.type === 'extinguishment'
          }"
          class="menu-item col-2 text-center"
          to="/firesafe-1/extinguishment"
          v-on:click.native="setFiresafe(1, 'extinguishment')"
        >
          EXTINGUISHMENT
        </router-link>
        <router-link
          :class="{
            active: firesafe.number === 2,
            'active-blue': firesafe.type === 'containment'
          }"
          class="menu-item col-2 text-center"
          to="/firesafe-2/containment"
          v-on:click.native="setFiresafe(2, 'containment')"
        >
          CONTAINMENT
        </router-link>
        <router-link
          :class="{
            active: firesafe.number === 2,
            'active-blue': firesafe.type === 'evacuation'
          }"
          class="menu-item col-2 text-center"
          to="/firesafe-2/evacuation"
          v-on:click.native="setFiresafe(2, 'evacuation')"
        >
          EVACUATION
        </router-link>
      </div>
      <div id="tabs">
        <div class="row" style="border: 1px solid #f3f3f4; border-bottom: 0;">
          <template v-for="dataValue in data[getType].Data">
            <div
              :class="{ active: getSelectedRCO === dataValue.Number }"
              :key="dataValue.Number"
              class="tab-item col text-center"
              v-on:click="setRCO(dataValue.Number)"
            >
              <span>{{ dataValue.Short | truncate(25) }}</span>
            </div>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import emsaJson from "../../data.json";

export default {
  name: "HeaderDataVis",
  data: function() {
    return {
      data: emsaJson
    };
  },
  mounted: function() {
    window.onscroll = function() {
      var element = document.getElementById("header-wrapper");
      if (
        document.body.scrollTop > 131 ||
        document.documentElement.scrollTop > 131
      ) {
        if (element) {
          element.classList.add("shadow");
        }
      } else {
        if (element) {
          element.classList.remove("shadow");
        }
      }
    };
  },
  computed: {
    firesafe: function() {
      return {
        number: parseInt(this.$route.params.number),
        type: this.$route.params.type
      };
    },
    getSelectedRCO: function() {
      return this.$store.getters.getSelectedRCO;
    },
    getType() {
      return this.$route.params.type.toUpperCase();
    }
  },
  methods: {
    setFiresafe(number, type) {
      this.$store.commit("setSelectedRCO", 0);
      this.$store.commit("setFiresafeNumber", number);
      this.$store.commit("setFiresafeType", type);
      this.$store.commit("toggleFadeInDown", false);
    },
    setRCO(rco) {
      this.$store.commit("setSelectedRCO", rco);
    }
  }
};
</script>

<style scoped></style>
